import { Container, Row, Col } from "reactstrap";
import styles from "./styles.module.scss";
import EditableText from "@/components/EditableText";
import clsx from "classnames";
import PropTypes from "prop-types";
import JobSearch from "@sourceflow-uk/job-search";
import "@sourceflow-uk/job-search/dist/bundle.css";
import JobCard from "@/components/Shared/JobCard";

import job_sector from "@/.sourceflow/jobs-job_titles.json";
// import job_location from '@/.sourceflow/jobs-jobs_by_location.json';
import job_type from "@/.sourceflow/jobs-job_type.json";
// import job_location from '@/.sourceflow/jobs-job_locations.json';

// import job_salary_anual from '@/.sourceflow/jobs-salary_-_annual.json';
// import job_salary_daily from '@/.sourceflow/jobs-salary_-_daily.json';
// import job_salary_hourly from '@/.sourceflow/jobs-salary_-_hourly.json';

export default function JobSearchIndex({
  className,
  global,
  pathPrefix,
  content_1,
  internal_jobs,
  sectorIds,
  categoryID = "69b6319c-d51b-4fa0-a7c3-96fd7192ca65",
}) {
  return (
    <section className={clsx(className, styles.root)}>
      <Container>
        {content_1 && (
          <EditableText
            content={content_1}
            path={`${pathPrefix}.content_1`}
            global={global}
            tag={`h2`}
            className={`mb-4`}
          />
        )}
        {internal_jobs ? (
          <div className="internal-jobs">
            <JobSearch
              translations={{
                "button.text": "",
                "filters.toggleButtonText": "Show Filters",
                "searchResults.resultsTotalCount":
                  "We have {{count}} matching jobs for you!",
              }}
              options={{
                urlFilters: {
                  mode: "active",
                  jobCategories: [job_sector, job_type],
                  pushToHistoryOnSearch: true,
                  changeURLOnFilterChange: true,
                },
                searchInput: {
                  locationInput: false,
                  searchTotalCount: false,
                },
                prefilters: {
                  //Internal jobs
                  "9c98959c-4af3-4934-bd43-6c56510ff799": [
                    "5d258c27-ba6c-4d61-a028-8536a66252ff",
                  ],
                },
                searchFiltersOptions: {
                  exclude: {
                    Internal: true,
                    "Teaching jobs": true,
                    "Job Sector": true,
                    "Jobs By Location": true,
                    "Job Tag": true,
                  },
                  categorySort: {
                    [job_sector.id]: function (a, b) {
                      const nameA = a.name.toUpperCase();
                      const nameB = b.name.toUpperCase();
                      return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
                    },
                  },
                  showResetSearchButton: true,
                  topLevelCategoryOrder: [
                    "Job Type",
                    "Length of Contract",
                    "Work Type",
                  ],
                },
                searchResults: ({ results }) =>
                  results?.length >= 1 ? (
                    <>
                      <Row>
                        {results.map(({ job, index }) => (
                          <Col lg={6} key={index} className="mb-4">
                            <JobCard
                              global={global}
                              all_jobs={true}
                              jobs_page={true}
                              {...job}
                            />
                          </Col>
                        ))}
                      </Row>
                    </>
                  ) : (
                    <>
                      <p className="text-center">
                        Sorry, we couldn't find any jobs matching your search.
                        Please try removing some filters or searching for
                        something else.
                      </p>
                    </>
                  ),
              }}
            />
          </div>
        ) : (
          <JobSearch
            translations={{
              "button.text": "",
              "filters.toggleButtonText": "Show Filters",
              "searchResults.resultsTotalCount":
                "Showing {{count}} matching jobs",
            }}
            options={{
              jobsPerPage: 12,
              urlFilters: {
                mode: "active",
                jobCategories: [job_sector, job_type],
                pushToHistoryOnSearch: true,
                changeURLOnFilterChange: true,
              },
              searchInput: {
                queryInput: false,
                locationInput: false,
                searchTotalCount: true,
              },
              // prefilters: {
              //     //Internal jobs
              //     [`${categoryID}`]: sectorIds,
              // },
              searchFiltersOptions: {
                nestedCategories: [job_type],
                exclude: {
                  Internal: true,
                  "Teaching jobs": true,
                  "Job Sector": true,
                  "Jobs By Location": true,
                  "Job Tag": true,
                },
                categorySort: {
                  [job_sector.id]: { key: "name", direction: "asc" },
                  // [length_of_contract.id]: function (a, b) {
                  //     const _a = length_of_contract.category_values.find(v => v.id === a.id);
                  //     const _b = length_of_contract.category_values.find(v => v.id === b.id);
                  //     return _a['_order'] < _b['_order'] ? -1 : 1;
                  // },
                },
                showResetSearchButton: true,
                topLevelCategoryOrder: [
                  "Job Type",
                  "Length of Contract",
                  "Work Type",
                ],
                filterFoldElement: <span className="caret"></span>,
                filterFoldDepth: 0,
                // initialFilterOpenState: false,
              },
              searchResults: ({ results }) =>
                results?.length >= 1 ? (
                  <>
                    <Row>
                      {results.map(({ job, index }) => (
                        <Col lg={6} key={index} className="mb-4">
                          <JobCard
                            global={global}
                            all_jobs={true}
                            jobs_page={true}
                            {...job}
                          />
                        </Col>
                      ))}
                    </Row>
                  </>
                ) : (
                  <>
                    <p className="text-center">
                      Sorry, we couldn't find any jobs matching your search.
                      Please try removing some filters or searching for
                      something else.
                    </p>
                  </>
                ),
            }}
          />
        )}
      </Container>
    </section>
  );
}
JobSearchIndex.defaultProps = {
  pathPrefix: "",
  className: "",
};

JobSearchIndex.propTypes = {
  pathPrefix: PropTypes.string,
  className: PropTypes.string,
};
